module.exports = __webpack_public_path__ + "static/media/41-web-or-mls-DSC06882.5fc8816f.jpg";